import React, { useEffect } from 'react';
import IvoriMethodUcatPage from '../../features/method/IvoriMethodUcatPage';

export default function IvoriMethodUcatRoute() {
  useEffect(() => {
    document.title = "The IVORI Method — Toulmin, Johnson-Laird, Gigerenzer & Rest | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <IvoriMethodUcatPage />;
}